module.exports = __webpack_public_path__ + "img/10627.04967807.png";